// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import moment, {Moment} from 'moment';
import * as PropTypes from 'prop-types';

import {ArchiveRecord} from 'archive/ArchiveConstants';
import {Owner, Permissions, PERMISSIONS_SHAPE} from 'auth/PermissionConstants';
import {TagSchema} from 'constants/RegistryConstants';
import {User} from 'constants/UserConstants';
import {SchemaTag} from 'folder-items/FileConstants';
import {ClientId, EntryVersion, FromServerId, ServerEntryVersion, ToServerId} from 'notebook/ELNConstants';
import {CidIdMap, CidNotePartProvenanceIdMap} from 'notebook/notes/NoteConstants';
import {BioentityNote, ServerNote} from 'notebook/util/NoteUtilConstants';

export const TEMPLATE_DAY_0 = '1970-01-01';

function TEMPLATE_DAY_0_MOMENT(): Moment {
  return moment(TEMPLATE_DAY_0);
}

const TEMPLATES_SEEN_FEATURE_BANNER_PREFERENCE = 'templates.seen_feature_banner';

export const TemplateCollectionShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  counts: PropTypes.shape({
    template: PropTypes.number.isRequired,
  }).isRequired,
  templates: PropTypes.array,
  permissions: PERMISSIONS_SHAPE,
});

export {TEMPLATE_DAY_0_MOMENT, TEMPLATES_SEEN_FEATURE_BANNER_PREFERENCE};

export interface TemplateCollectionSummary {
  id: string;
  url: string;
  name: string;
  description: string;
  createdAt: string;
  modifiedAt: string;
  counts: {template?: number; subtemplate?: number};
}

interface BaseTemplateSummary {
  editURL: string;
  templateCollection: TemplateCollectionSummary;
  id: string;
  name: string;
  creator: string;
  creatorId: string;
  createdAt: string;
  modifiedAt: string;
}

export interface SubtemplateSummary extends BaseTemplateSummary {}

export interface TemplateSummary extends BaseTemplateSummary {
  preview?: string;
}

export interface Subtemplate extends BaseTemplate {
  subtemplateVersion: SubtemplateVersion;
}

export interface FromServerSubtemplate extends BaseTemplate {
  subtemplateVersion: FromServerSubtemplateVersion;
}

export type SubtemplateVersion = {
  noteVersion: BioentityNote;
  apiId: string;
} & ClientId;

export interface FromServerSubtemplateVersion extends FromServerId {
  api_identifier: string;
  noteVersion: ServerNote<FromServerId>;
  creator: User;
  createdAt: string;
  modifiedAt: string;
  subtemplate: SubtemplateSummary;
  parentId: number | null;
}

interface BaseTemplate {
  id: string;
  name: string;
  editURL: string;
  latestVersionId: number;
  templateCollection: TemplateCollectionSummary;
  permissions: Permissions;
  archiveRecord: ArchiveRecord | null;
  creator: string;
  creatorId: string;
  createdAt: string;
  modifiedAt: string;
  preview?: string;
}

export interface TemplateTagSchemas {
  tagSchema: TagSchema | null;
  tags: Array<SchemaTag>;
}

export interface Template extends BaseTemplate, TemplateTagSchemas {
  templateVersion: TemplateVersion;
  // isFillIn: boolean;
}

export interface TemplateUpdateResponse extends Template {
  cidIdMap: CidIdMap;
  cidNotePartProvenanceIdMap?: CidNotePartProvenanceIdMap;
}

export interface FromServerTemplate extends BaseTemplate, TemplateTagSchemas {
  templateVersion: FromServerTemplateVersion;
}

export type TemplateVersion = {
  entryVersion: EntryVersion;
  apiId: string;
} & ClientId;

export interface FromServerTemplateVersion extends FromServerId {
  apiIdentifier: string;
  entryVersion: ServerEntryVersion<FromServerId>;
  creator: User;
  createdAt: string;
  modifiedAt: string;
  template: TemplateSummary;
  parentId: number | null;
}

export interface ToServerSubtemplate {
  name: string;
  subtemplateVersion: ToServerSubtemplateVersion;
}

export interface ToServerSubtemplateVersion extends ToServerId {
  noteVersion: ServerNote<ToServerId>;
}

export interface ToServerTemplate {
  name: string;
  templateVersion: ToServerTemplateVersion;
}

export interface ToServerTemplateVersion extends ToServerId {
  entryVersion: ServerEntryVersion<ToServerId>;
}

export interface TemplateUpdateObject {
  name?: string;
  templateCollectionId?: string;
}

export interface TemplateCollection {
  id: string;
  url: string;
  name: string;
  description: string;
  owner?: Owner;
  counts: {
    template?: number;
    subtemplate?: number;
  };
  templates?: Array<TemplateSummary>;
  subtemplates?: Array<SubtemplateSummary>;
  templateCollectibles?: Array<BaseTemplateSummary>;
  permissions: Permissions;
  createdAt: string;
  modifiedAt: string;
}
